import React, { useMemo } from "react";
import { useDispatch } from "react-redux";
import { useImmer } from "use-immer";

import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import { TinybirdEventType } from "@intelligems/ig-types/dtos/analytics-events/custom-events";
import { Table, TableBody, TableCell, TableRow, useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";
import { setCustomJsEventIdentifier } from "@src/store/slices/customEvents";
import { getTimeAgo } from "@src/utils/dateConverters";

interface Event {
  name: string;
  lastTriggered: string;
}

interface JsEventTableProps {
  events: TinybirdEventType[];
  onEventNotListed: () => void;
}

export const JsEventTable = ({
  events,
  onEventNotListed,
}: JsEventTableProps) => {
  const dispatch = useDispatch();
  const [selectedEvent, setSelectedEvent] = useImmer<string>("");
  const theme = useTheme();
  const handleEventNotListedClick = () => {
    setSelectedEvent("");
    dispatch(setCustomJsEventIdentifier({ identifier: "" }));
    onEventNotListed();
  };
  const now = useMemo(() => {
    return Date.now();
  }, []);

  return (
    <Grid
      style={{
        // eslint-disable-next-line ig-fe-requirements/no-hardcoded-hex-colors -- alpha/transparent; no ig-theme token
        border: "1px solid #0000003B",
        borderRadius: "5px",
        width: "100%",
      }}
      marginTop={"15px"}
    >
      <Table
        style={{
          borderCollapse: "collapse",
          width: "100%",
          borderRadius: "5px",
        }}
      >
        <TableBody>
          {events.map((event) => {
            return (
              <TableRow
                key={event.event_id}
                sx={{
                  "&:hover": { cursor: "pointer" },
                  backgroundColor:
                    selectedEvent === event.event_id
                      ? theme.igBackgroundColors.interactive.neutral.active
                      : "transparent",
                }}
                onClick={() => {
                  dispatch(
                    setCustomJsEventIdentifier({ identifier: event.event_id })
                  );
                  setSelectedEvent(event.event_id);
                }}
              >
                <TableCell sx={{ padding: "8px 24px", textAlign: "left" }}>
                  <IgTypography>{event.event_id}</IgTypography>
                </TableCell>
                <TableCell sx={{ padding: "8px 24px", textAlign: "right" }}>
                  <IgTypography>
                    Last Triggered {getTimeAgo(event.last_event_ts || "", now)}
                  </IgTypography>
                </TableCell>
              </TableRow>
            );
          })}
          <TableRow>
            <TableCell
              sx={{
                padding: "8px 24px",
                cursor: "pointer",
                borderBottom: "none",
              }}
              onClick={handleEventNotListedClick}
              colSpan={2}
            >
              <IgTypography>My event is not listed here</IgTypography>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Grid>
  );
};
